import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './sendOutGoods.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { SendOutGoods } from "model/scanCodeOrder/sendOutGoods.model";

export interface SendOutGoodsDetailsProps extends DetailsStateAndDispatchProps<SendOutGoods>,
  RouteComponentProps, StateProps, DispatchProps {
}
const SendOutGoodsDetails: FC<SendOutGoodsDetailsProps> = (props) => {
  return (
    <DetailsPage<SendOutGoods>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<SendOutGoods>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ sendOutGoods }: RootState) => ({
  entity: sendOutGoods.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(SendOutGoodsDetails);
